import { render, staticRenderFns } from "./StepContactsVars.vue?vue&type=template&id=5e59b042&scoped=true"
import script from "./StepContactsVars.vue?vue&type=script&lang=js"
export * from "./StepContactsVars.vue?vue&type=script&lang=js"
import style0 from "./StepContactsVars.vue?vue&type=style&index=0&id=5e59b042&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e59b042",
  null
  
)

export default component.exports